function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.9112 2.7125H2.4112C1.6112 2.7125 0.961197 3.3625 0.961197 4.1625V11.8375C0.961197 12.6375 1.6112 13.2875 2.4112 13.2875H14.9112C15.7112 13.2875 16.3612 12.6375 16.3612 11.8375V4.1625C16.3612 3.3625 15.7112 2.7125 14.9112 2.7125ZM14.9112 3.5875C15.0362 3.5875 15.1362 3.6125 15.2362 3.6875L9.0112 7.4625C8.7862 7.5875 8.5362 7.5875 8.3112 7.4625L2.0862 3.6875C2.1862 3.6375 2.2862 3.5875 2.4112 3.5875H14.9112ZM14.9112 12.3875H2.4112C2.1112 12.3875 1.8362 12.1375 1.8362 11.8125V4.5625L7.8362 8.2125C8.0862 8.3625 8.3612 8.4375 8.6362 8.4375C8.9112 8.4375 9.1862 8.3625 9.4362 8.2125L15.4362 4.5625V11.8125C15.4862 12.1375 15.2112 12.3875 14.9112 12.3875Z",
  fill: "#323F4B"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.661194)"
})));
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.6c46d395579cdf3c0a247d1277277119.svg";
export { ForwardRef as ReactComponent };